"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function cro(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M11.9999 2L3.5 7.01119V16.9888L11.9999 22L20.4997 16.9888V7.01119L11.9999 2ZM17.9894 15.5123L11.9999 19.0022L6.01032 15.5123V8.4877L11.9999 4.95302L17.9894 8.4877V15.5123Z", fill: color }),
        React.createElement("path", { d: "M11.9999 4.95302V2L3.5 7.01119V16.9888L11.9999 22V19.0022L6.01032 15.5123V8.4877L11.9999 4.95302Z", fill: color }),
        React.createElement("path", { d: "M11.9999 19.0022L12.0001 21.9553L20.5 16.9441L20.4997 7.01119L11.9999 2V4.95302L17.9897 8.44295V15.4676L11.9999 19.0022Z", fill: color }),
        React.createElement("path", { d: "M16.0081 14.3039L12.0004 16.6305L8.03671 14.3039V9.65061L12.0004 7.32399L16.0081 9.65061V14.3039Z", fill: color }));
}
exports["default"] = cro;
//# sourceMappingURL=cro.js.map